import _ from 'lodash';
import $ from 'jquery';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

const requestApi = function (data, path, type) {
  if (!type) {
    type = 'GET';
  }
  const url = op.webroot + path;

  return $.ajax({
    type,
    url,
    data: { data: JSON.stringify(data) },
    dataType: 'json',
  });
};

module.exports = {
  loadQuiz() {
    if (typeof op === 'undefined' || typeof op.quiz === 'undefined') {
      return false;
    }

    AppDispatcher.dispatch({
      type: ActionTypes.QUIZ_LOAD_SUCCESS,
      quiz: op.quiz,
      questions: op.quiz.questions,
      score: 0,
    });
  },
  // Saglabāt jautājumu
  saveAnswer(answer_id, question_id, result) {
    const self = this;

    AppDispatcher.dispatch({
      type: ActionTypes.QUIZ_ANSWER_SAVE,
      answer_id,
      question_id,
      result,
    });
  },
  // Saglabāt atbildes DB
  saveResults(data, quiz_id, hide) {
    const self = this;
    data = { data, quiz_id, hide };

    const request = requestApi(data, `/quiz/save_results/${quiz_id}/1.json`, 'POST');

    // success
    request.done((data) => {
      if (!_.isEmpty(data.status) && data.status == 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.QUIZ_RESULTS_SAVE,
        });
      } else if (data.status == 'error') {
        // self.skipQuestion(id);
        AppDispatcher.dispatch({
          type: ActionTypes.QUIZ_RESULTS_SAVE_FAIL,
        });
      }
    });
    request.fail((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.QUIZ_RESULTS_SAVE_FAIL,
      });
    });
  },

  hideResults(quiz_id, hide) {
    const self = this;
    const data = { hide, quiz_id };
    const request = requestApi(data, `/quiz/hide_results/${quiz_id}/1.json`, 'POST');
  },
};
